import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'
import { BrandKit } from './Carousels/BrandKit'
import { Uploads } from './Carousels/Uploads'
import { StockPhotos } from './Carousels/StockPhotos'
import { StockVideos } from './Carousels/StockVideos'
import { UploadedMediaCarouselProps } from './Types'
import { Ai } from './Carousels/Ai'

export const MediaCarousels = (props: UploadedMediaCarouselProps) => {
  const { accept } = props
  const { data } = useBrandKits({
    select: (data) => data.filter((brandKit) => brandKit.media_files.length > 0),
    cacheTime: 1000 * 60 * 5,
  })

  return (
    <>
      <Ai />
      {data?.map((brandKit) => (
        <BrandKit key={brandKit.id} brandKit={brandKit} {...props} />
      ))}
      <Uploads {...props} />
      {accept.includes('image') && <StockPhotos />}
      {accept.includes('video') && <StockVideos />}
    </>
  )
}
